import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { GetFilesInMyFolder, GetMyFolders, DeleteFolder, GetMyDocuments } from "../_store/resources.actions";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MoveFilesComponent } from '../move-files-dialogue/move-files.component'
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { filterResults } from "../../../../app.constants";
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';


@Component({
    selector: 'app-my-folders',
    templateUrl: './my-folders.component.html',
    styleUrls: ['./my-folders.component.scss']
})
export class MyFoldersComponent implements OnInit {
    folderList: Array<any> = [];       // stores list of folders or subfolders and files in the main folder
    fileList: Array<any> = [];
    showFilesInFolder: boolean = false; // flag to check whether listing all folders or files in main folder
    folderId: string;                  // stores currently opened folder id
    folderName: string;
    folderNavigationArr: Array<any> = [];                // stores currently opened folder name
    filteredFiles;
    searchInput = new FormControl();

    constructor(
        private store: Store<AppState>,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        // invoke function to get all folders created by self
        // this.getMyFolders();
        // this.getMyFiles();

        /* listening to search input */
        this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
            this.filteredFiles = filterResults(this.fileList, searchString);
        });
    }

    // gets all folders created by self
    getMyFolders() {
        this.router.navigate([], { queryParams: {} });
        this.folderNavigationArr = []
        this.showFilesInFolder = false;
        this.store.dispatch(new GetMyFolders());
        this.store.select(state => state.resources.myFolders).pipe().subscribe(folderList => {
            this.folderList = folderList;
        })
    }


    getMyFiles() {
        // this.store.dispatch(new GetMyDocuments());
        // this.store.select(state => state.resources.myDocuments).subscribe(docList => {
        //     this.fileList = docList;
        //     this.filteredFiles = docList;
        // });
    }

    /* 
        gets content of selected folder
        @param {folderId} id of the folder clicked on
    */
    getFilesInFolder(folderId, folderName) {
        if (typeof folderId == "undefined") {
            return;
        }
        this.router.navigate([], { queryParams: {} });
        this.router.navigate([], { queryParams: { id: folderId } });

        this.showFilesInFolder = true;
        this.folderId = folderId;
        this.folderName = folderName;
        let clickedFolderIndex;

        this.folderNavigationArr.push({ id: folderId, name: folderName });

        this.folderNavigationArr.map((value, index) => {
            if (value.name == folderName) {
                clickedFolderIndex = index;
                this.folderNavigationArr.length = clickedFolderIndex + 1;  // increment by one to keep the current element.
            }
        })

        // this.store.dispatch(new GetFilesInMyFolder(folderId));

        this.store.select(state => state.resources.filesInFolder).pipe().subscribe(filesInFolderList => {
            if (typeof filesInFolderList.subFolderList != "undefined") {
                this.folderList = filesInFolderList.subFolderList;
            }
            else {
                this.folderList = []
            }

            if (typeof filesInFolderList.docsList != "undefined") {
                this.fileList = filesInFolderList.docsList;
            }
            else {
                this.fileList = []
            }
        })
    }

    showConfirmDeleteDialog() {
        let previousDeleteFolderIndex;  // to store index of the previos element i.e element before deleted element
        let previousDeleteFolderId;     // to store folder id of the previos element i.e element before deleted element

        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: '500px',
            panelClass:'cmp-modal',
            data: {
                text: 'Are you sure you want to delete? '
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new DeleteFolder(this.folderId));
                this.store.select(state => state.resources.deleteFolderRes).pipe().subscribe(response => {
                    if (response['success']) {
                        // folderNavigationArray maintains an array of opened folders.
                        this.folderNavigationArr.map((value, index) => {
                            // check for deleted folder name in the array
                            if (value.name == this.folderName) {
                                // get the index of element before deleted element
                                previousDeleteFolderIndex = index - 1;
                                // if index is 0 navigate to parent folder
                                if (index == 0) {
                                    document.getElementById("myFolders").click();
                                    return;
                                }
                                // stores the folder id of previous element and navigate to that folder
                                previousDeleteFolderId = this.folderNavigationArr[previousDeleteFolderIndex].id;
                                document.getElementById("folder_" + previousDeleteFolderId).click();
                                return;
                            }
                        })

                    }
                })
            }
        });
    }

    showMoveToFolderDialog(folderID: string = '', fileFlag: boolean = false) {
        const dialogref = this.dialog.open(MoveFilesComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'task-detail-modal',
            data: {
                fileId: folderID,
                Flag: fileFlag
            }
        });
    }

    showMoveToFolder() {}

}
